"use client";

import Script from "next/script";

const PIXEL_ID = process.env.NEXT_PUBLIC_REDDIT_PIXEL_ID;

declare global {
    interface Window {
        rdt?: (command: string, event: string, payload?: Record<string, unknown>) => void;
    }
}

// Pixel ids are our own env, but we still guard the value that gets interpolated
// into an inline <script> so a malformed env can never inject markup.
const SAFE_ID = /^[a-zA-Z0-9_-]+$/;

/**
 * Reddit advertising Pixel. Loads the Reddit tracking library and fires a
 * `PageVisit` on load. Server-side conversions (SignUp) are sent separately via
 * the Conversions API (`lib/attribution/reddit.ts`) so they survive mobile-app
 * query-stripping and ad-blockers.
 *
 * Renders nothing when NEXT_PUBLIC_REDDIT_PIXEL_ID is unset — safe to ship
 * before the pixel id exists.
 */
export function RedditPixel() {
    if (!PIXEL_ID || !SAFE_ID.test(PIXEL_ID)) return null;

    return (
        <Script id="reddit-pixel" strategy="afterInteractive">
            {`
!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
rdt('init','${PIXEL_ID}');
rdt('track','PageVisit');
            `}
        </Script>
    );
}
